import { Component } from '@angular/core';
import { SavedPin } from '@models/teranet';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SalePinActions, SalePinState } from '@state/sale_pins';
import { MatterLRO, TeranetDocket } from '@models/matter';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';

@UntilDestroy()
@Component({
	selector: 'app-teranet-default',
	templateUrl: './default.component.html',
	styleUrls: ['./default.component.scss'],
	standalone: false,
})
export class TeranetDefaultComponent {
	public parentPins: SavedPin[];
	public adjacentPins: SavedPin[];

	@Select(SalePinState.getParents) parentPins$: Observable<SavedPin[]>;
	@Select(SalePinState.getAdjacent) adjacentPins$: Observable<SavedPin[]>;
	@SelectSnapshot(SelectedMatter.teranetDocket) docket: TeranetDocket;
	@SelectSnapshot(SelectedMatter.id) saleId: string;
	@SelectSnapshot(SelectedMatter.LRO) selectedLRO: MatterLRO;
	@SelectSnapshot(SalePinState.getSelected) selectedPin: SavedPin;

	public showNotes = true;
	public selectedNotes: string[];
	public ICON = ICON;

	constructor(
		private routeService: NavigationService,
		private dialog: MatDialog,
	) {
		this.parentPins$.pipe(untilDestroyed(this)).subscribe((value) => {
			this.parentPins = value;

			if (value?.[0]?.pin) {
				if (!this.selectedPin) {
					this.selectPin(value[0]);
				}
			}
		});

		this.adjacentPins$.pipe(untilDestroyed(this)).subscribe((value) => {
			this.adjacentPins = value;
		});
	}

	@Dispatch()
	selectPin(pin: SavedPin) {
		return new SalePinActions.SelectPin(pin.pin);
	}
}
